import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import StyledButton from '../StyledHtmlElements/Button';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmResettForm from './ConfirmResettForm';
import Box from '../StyledHtmlElements/Box';
import LoginInForm from './LoginInForm';
import ResetPasswordForm from './ResetPasswordForm';
import { useUser } from '@/hooks/user-user';
import { useToast } from '@/hooks/use-toast';
import allRoutes, { RoutePath } from '@/lib/routes';

const Login = () => {
  const [forgotPasswortEmail, setForgotPasswortEmail] = useState('');
  const [isForcePwChange, setIsForcePwChange] = useState(false);
  const router = useNavigate();
  const { accessibleProtectedRoutes, signOut, userIsSet } = useUser();
  const { toast } = useToast();

  useEffect(() => {
    if (userIsSet) {
      const hasAccess = accessibleProtectedRoutes.length > 0;
      const routeToNav: RoutePath = '/navigation';

      //if no entry in accessibleProtectedRoutes, this means to user has no access to any route
      // so we sign out and redirect to the home page after 3 seconds
      if (!hasAccess) {
        signOut();
        toast({
          title: 'Zugriff verweigert',
          description: 'Sie haben keinen Zugriff auf diese Applikation. Bitte kontaktieren Sie den Administrator.',
          variant: 'destructive',
        });

        setTimeout(() => {
          router(allRoutes.homePage.route);
        }, 3000);
      }

      router(routeToNav);
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userIsSet]);

  return (
    <section id="auth-form" className="pt-[15svh]">
      <Box className="m-auto w-[35%] min-w-[300px] max-w-[380px]  px-4 pb-2 flex flex-col">
        {(forgotPasswortEmail || isForcePwChange) && (
          <ConfirmResettForm
            setForgotPasswortEmail={setForgotPasswortEmail}
            setIsForcePwChange={setIsForcePwChange}
            forgotPasswortEmail={forgotPasswortEmail}
            isForcePwChange={isForcePwChange}
          />
        )}

        {!forgotPasswortEmail && !isForcePwChange && (
          <Tabs defaultValue="login" className="flex flex-col justify-center gap-4">
            <TabsList className="m-auto">
              <TabsTrigger
                value="login"
                className="data-[state=active]:bg-secondaryColor data-[state=active]:text-neutralDark">
                Login
              </TabsTrigger>

              <TabsTrigger
                value="resetPassword"
                className="data-[state=active]:bg-secondaryColor data-[state=active]:text-neutralDark">
                Password vergessen
              </TabsTrigger>
            </TabsList>

            <TabsContent value="login">
              <>
                <LoginInForm setIsForcePwChange={setIsForcePwChange} setForgotPasswortEmail={setForgotPasswortEmail} />
                <StyledButton onClick={() => router('/')} className="w-full mt-2" variant="link">
                  Zurück zur Startseite
                </StyledButton>
              </>
            </TabsContent>

            <TabsContent value="resetPassword">
              <ResetPasswordForm setForgotPasswortEmail={setForgotPasswortEmail} />
            </TabsContent>
          </Tabs>
        )}
      </Box>
    </section>
  );
};

export default Login;
